import { createContext, useContext, useSyncExternalStore } from "react";

export type ElementDraft = {
  x: number;
  y: number;
  w: number;
  h: number;
  fontSize?: number;
  text?: string;
};

// Lets the studio show in-progress edits without passing a new composition on every change.
export type ElementDraftSource = {
  subscribe: (listener: () => void) => () => void;
  getDraft: (externalId: string) => ElementDraft | undefined;
};

export const ElementDraftContext = createContext<ElementDraftSource | null>(
  null,
);

const subscribeToNothing = () => () => {};

export function useElementDraft(externalId: string) {
  const source = useContext(ElementDraftContext);

  return useSyncExternalStore(source?.subscribe ?? subscribeToNothing, () =>
    source?.getDraft(externalId),
  );
}
